export default "__VITE_ASSET__DSidPtqn__"